import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-wrapper drv-px-0-5 drv-py-2" }

import { computed, onUnmounted, ref } from "vue";
import {
  IPlatform,
  IBaseBasic,
  EAuthTypes,
  ETelematicsMessagesKeys,
} from "../../../../types";
import { useUIKit } from "draivn-ui-kit";
import {
  deleteRevokeConnection,
  useOnboardingStore,
} from "../../../../services";

const OAUTH_BROADCAST_CHANNEL = "draivn-oauth";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseOauth',
  props: {
    modelValue: {},
    platform: {},
    disable: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const $uiKit = useUIKit();
const { sessionId } = useOnboardingStore();

const props = __props;

const isDiasbled = computed<boolean>(() => {
  return props.disable || isLoading.value;
});

const isLoading = ref<boolean>(false);

const emit =
  __emit;

const EMPTY_MODEL = { type: EAuthTypes.OAUTH2, username: "", password: "" };

const model = computed<IBaseBasic>({
  get() {
    return props.modelValue ?? structuredClone(EMPTY_MODEL);
  },
  set(value: IBaseBasic) {
    emit("update:modelValue", value);
  },
});

// const buttonLabelKey = computed<string>(() => {
//   switch (props.platform.const) {
//     case EPlatformName.SAMSARA:
//       return ETelematicsMessagesKeys.SAMSARA_OAUTH_BUTTON_TITLE;
//     case EPlatformName.MOTIVE:
//       return ETelematicsMessagesKeys.MOTIVE_OAUTH_BUTTON_TITLE;
//     default:
//       return ETelematicsMessagesKeys.BASE_OAUTH_BUTTON_TITLE;
//   }
// });

const authHandler = (event: MessageEvent<string>) => {
  if (typeof event.data === "string" && event.data.startsWith("DraivnOauth|")) {
    const response = JSON.parse(event.data.replace("DraivnOauth|", ""));
    handleAuthResponse(response);
  }
};

let broadcastChannel: BroadcastChannel | null = null;

const handleAuthResponse = (response: {
  state?: string;
  error?: string;
  token?: string;
}) => {
  if (response.state !== sessionId) {
    return;
  }

  if (response.error) {
    $uiKit.notify({
      message: ETelematicsMessagesKeys.OAUTH_ERROR_TITLE,
      caption: response.error,
      icon: "error_outline",
      type: "draivn-toast-notify",
    });
  } else {
    model.value = {
      type: EAuthTypes.OAUTH2,
      username: response.state,
      password: response.token ?? "",
    };
  }

  cleanupAuthListeners();
};

const cleanupAuthListeners = () => {
  window.removeEventListener("message", authHandler);
  broadcastChannel?.close();
  broadcastChannel = null;
};

const connectHandler = () => {
  const url = `${process.env.VUE_APP_BASE_URL}/api/authorize/${props.platform.const}/${sessionId}`;
  window.open(url, "_blank");
  window.addEventListener("message", authHandler);

  if (typeof BroadcastChannel !== "undefined") {
    broadcastChannel?.close();
    broadcastChannel = new BroadcastChannel(OAUTH_BROADCAST_CHANNEL);
    broadcastChannel.onmessage = (event: MessageEvent<string>) => {
      authHandler(event);
    };
  }
};

onUnmounted(() => {
  cleanupAuthListeners();
});

const revokeLoading = ref<boolean>(false);
const clearConnection = async () => {
  revokeLoading.value = true;
  const success = await deleteRevokeConnection({
    tokenId: model.value.password,
    type: props.platform.const,
  });
  if (success) {
    emit("update:modelValue", null);
  }
  revokeLoading.value = false;
};

const hasError = computed<boolean>(() => {
  return !model.value.username || !model.value.password;
});

__expose({
  hasError,
});

return (_ctx: any,_cache: any) => {
  const _component_d_btn = _resolveComponent("d-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.modelValue)
      ? (_openBlock(), _createBlock(_component_d_btn, {
          key: 0,
          class: _normalizeClass(["auth-btn drv-color-n0", {
        'drv-bg-color-b400': !isLoading.value,
        'drv-bg-color-n500': isLoading.value,
      }]),
          onClick: connectHandler,
          loading: isLoading.value,
          icon: "arrow-up-right",
          label: _ctx.$t(_unref(ETelematicsMessagesKeys).BASE_OAUTH_BUTTON_TITLE),
          disable: isDiasbled.value
        }, null, 8, ["class", "loading", "label", "disable"]))
      : (_openBlock(), _createBlock(_component_d_btn, {
          key: 1,
          class: "connected-status drv-color-n0 drv-bg-color-g400",
          icon: "circle-check",
          label: _ctx.$t(_unref(ETelematicsMessagesKeys).OAUTH_CONNECTED_TITLE)
        }, null, 8, ["label"])),
    (_ctx.modelValue)
      ? (_openBlock(), _createBlock(_component_d_btn, {
          key: 2,
          variant: "secondary",
          disable: isLoading.value,
          loading: revokeLoading.value,
          onClick: clearConnection,
          label: _ctx.$t(_unref(ETelematicsMessagesKeys).OAUTH_REVOKE_TITLE)
        }, null, 8, ["disable", "loading", "label"]))
      : _createCommentVNode("", true)
  ]))
}
}

})